import cjson from 'compressed-json';
import { TemplatePortal } from '@angular/cdk/portal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CallStage } from 'src/app/enums/CallStage';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { JdDataService } from 'src/app/jd-data.service';
import { Location } from '@angular/common';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import * as _ from 'underscore';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';


@Component({
    selector: 'app-report-industries',
    templateUrl: './report-industries.component.html',
    styleUrls: ['./report-industries.component.scss'],
    standalone: false
})
export class ReportIndustriesComponent implements OnInit {

  constructor(
    private personSerarchService: PersonSearchService, private localstorageservice: LocalStorageService, private router: Router,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService
    , private talentInsightsService: TalentInsightsService, private jdService: JdDataService, private location: Location, private personSearchService: PersonSearchService,
  private route: ActivatedRoute) {

    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');
      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
        }
      }
      this.setUpdatedData(null);
    });

  }

  industries: any;
  industriesData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'graph', 'job_doc_count', 'median_salary'];
  @ViewChild('industriesTbSort') industriesTbSort: MatSort;

  totalResultCount: number = 0;
  aggregatescount: number = 50;
  start: number = 0;
  end: number = 10;
  currentPage: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  talentfilterdata: any = {};
  apiCalled: boolean = false;
  subscriptions: Array<Subscription> = [];
  insightsExportSubscription: Subscription = null;
  /**Sorted data of industries based on pageCount */
  industriesSortData: any;
  industrydataai: any;

  /**
   * Mapping of key and text value of headers
   * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
   */
  tableHeaderObj = {
    "TopIndustries": "Top Industries",
    "TalentCount": "Talent Count",
    "%OfTotal": "% of Total",
    "JobDemand": "Job Posts",
    "MedianSalary": "Salary Range"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  combinedAggregates: any;
  combinedSkills: any[] = [];
  combinedJobtitle: any[] = [];
  combinedIndustry: any[] = [];
  combinedLocation: any[] = [];
  hasJobDemand: boolean = false;
  currencyData: any[] = [];
  filteredCurrencies: any[] = []
  selectedCurrency: any = null;
  target_currency_rate: number = 1
  target_fav_icon: string = 'fa-dollar-sign';
  currency_symbol: string = '$';
  currency: string = '';
  hasMedianSalary: boolean = false;
  filterData: any;
  aiSuggestions: any = {};
  industryJobAggregates: any = [];
  filterType: string[] = [];

    sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  industriesTabPayload:any
  hasJobListingAccess:any

  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')

    if (!hasEUPSAccess)
      return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

    isComingFromJD: Boolean = false;
  isComingFromNLSearch: Boolean = false;
  filters: any;

  ngOnInit(): void {
    if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    this.getCurrencyData();
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails
      this.getCurrencyData('filterChange');
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string }}) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.INDUSTRIES) {
                this.filterType = res?.filterType || [];

        this.getCurrencyData('jdUpdate');
      }
    });
    this.subscriptions.push(jdUpdateEvent);

          const aiSuggestionSub = this.talentInsightsService.aiSuggesionData.subscribe(data => {
      this.aiSuggestions = data;
      if(!this.aiSuggestions) {
        this.aiSuggestions = this.talentInsightsService.getAISuggestionData();
      }
      this.setUpdatedData();
    });
    this.subscriptions.push(aiSuggestionSub);
    this.hasJobListingAccess = this.localstorageservice.getItem('hasjoblistingaccess')
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.getIndustry();
    this.personSerarchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getIndustry() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_industry';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSerarchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.apiCalled = true;
      this.totalResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.current_industry;
      this.industriesSortData = tempData;
      this.totalCount = tempData.length;
      this.industriesData = tempData.slice(this.start, this.end);
      this.industries = new MatTableDataSource(this.industriesData);
      this.industries.sort = this.industriesTbSort;
     if((!this.filterData && this.filterType?.length == 0) || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'pastjobtitle')
    ||((this.filterType?.length > 0 && (this.filterType?.includes('skills') || this.filterType?.includes('jobtitle') || this.filterType?.includes('industry') || this.filterType?.includes('company'))))) {
         this.getCurrency();
     } else if(this.filterData?.filterType == 'allfilters' && !this.isComingFromJD && !this.isComingFromNLSearch){
       this.industriesSortData.map(location => {
          location.median_salary = "N/A";
          location.confidence_score = "N/A";
          location.job_doc_count = 0;
        return location;
      });
      this.localstorageservice.setItem('jobCurrency', 'USD');
          this.localstorageservice.setItem('currencyCountry', null);
              this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
             const currency = this.localstorageservice.getItem('jobCurrency');

 if(currency) {
      const selectedCurrency = this.currencyData.find((x:any) => x.target_currency === currency);
      if(selectedCurrency) {
        this.selectedCurrency = selectedCurrency;
        this.target_currency_rate = selectedCurrency.rate;
        this.currency = selectedCurrency.target_currency;
        this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
        this.currency_symbol = selectedCurrency.target_currency_symbol;
      }
    }
    })
     }

     else {
      this.setindustryJobAggregates();
     }
      this.manualSort();

        this.getindustriesdataai(this.industriesSortData)

    });
  }

  getIndustryPercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    this.manualSort();
  }

  manualSort() {
    this.reSortArr(this.industriesTbSort);
  }

  reSortArr(sort) {
    const tempData = this.industriesSortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.industriesData = tempData.slice(this.start, this.end);
      this.industries = new MatTableDataSource(this.industriesData);
      this.industries.sort = this.industriesTbSort;
      return;
    }

    this.industriesSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'job_doc_count': return this.compare(a.job_doc_count, b.job_doc_count, isAsc);
        default: return 0;
      }
    });
    this.industriesData = this.industriesSortData.slice(this.start, this.end);
    this.industries = new MatTableDataSource(this.industriesData);
    this.industries.sort = this.industriesTbSort;
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getIndustryIcon(industryName) {
    let iconName = GlobalService.getIndustryIcon(industryName)
    return `fa-solid fa-${iconName}`
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
  * Handel Redirection to person search listing
  * @param type
  * @param key
  */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;
 this.filters = this.filterDataHandlerService.fetchFilterData;

    const redirectFilters: Partial<FilterParams> = {
      insightsFilterData: this.filters,
    };

    switch (type) {
      case 'industry': redirectFilters['mandatoryindustries'] = [key]; break;
    }

    const aggReq = this.aggService.getRequestWithFilters();
       if (aggReq?.continentstobeincluded) {
         redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
       }
       if (aggReq?.nlsearchquery) {
         redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
       }

       const uniqueKey = this.hashService.generateUniqueHash();
       localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

       // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
       // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
       // that window.open() clones into the new tab.
       const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

       let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

       if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
         url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
       }

       window.open(url, '_blank');
  }

  getindustriesdataai(data) {
    let industrydata: any;
    industrydata = data.map(x => {
      let res: any = {};
      res['Top Industries'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getIndustryPercentage(x.doc_count) + '%';
      res['Job Posts'] = x.job_doc_count || 0;
      if(x.median_salary_max){
        res[' median salary offered max'] = x.median_salary_max;
      }
      if(x.median_salary_min){
        res['median salary offered min'] = x.median_salary_min;
      }
      res['Salary currency'] = this.selectedCurrency?.target_currency
      return res;

    })
    this.modifyCurrencyDataForAi(industrydata);
    this.industrydataai = {
      industries: industrydata
    }
    if (industrydata.length == 0)
      this.industrydataai = null;
  }

  /**
   * Format currency data
   * @param aiData Already formatted ai data
   * @returns
   */
  modifyCurrencyDataForAi(aiData) {
    if (!aiData || !Array.isArray(aiData)) {
      return;
    }
    aiData.forEach(item => {
      if (item['median salary offered max']) {
        item['median salary offered max'] = item['median salary offered max'] * this.target_currency_rate;
      }
      if (item['median salary offered min']) {
        item['median salary offered min'] = item['median salary offered min'] * this.target_currency_rate;
      }
      if (this.selectedCurrency?.target_currency) {
        item['Salary currency'] = this.selectedCurrency?.target_currency
      }
    })
  }


  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if (requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.INDUSTRIES) return;

    this.tableHeaderName = [this.tableHeaderObj['TopIndustries'], this.tableHeaderObj['TalentCount'], this.tableHeaderObj['%OfTotal'], this.tableHeaderObj['JobDemand'], this.tableHeaderObj['MedianSalary']];
       const industryDataForExport = this.industriesSortData.map(industry => {
      return {
        ...industry,
        job_doc_count: industry.job_doc_count || '—',
        median_salary: industry.median_salary != 'N/A' ? industry.median_salary : '—',
      }
    });
    const payloadForInsightsExport = {
      tab: 'industries',
      totalresultcount: this.totalResultCount,
      industries: industryDataForExport.map((ind: any) => ({ ...ind, icon: this.getIndustryIcon(ind.key) })),
      tableHeader: this.tableHeaderName,
      currencySymbol: this.currency_symbol
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }


  getJobsAggregates() {
    this.hasMedianSalary = true;
        this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
      const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
        const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'industry-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],

    }
       if (this.isComingFromJD || this.isComingFromNLSearch) {
          payload['jobDescriptionKeys'] = {
            jobtitles: jobtitles,
            mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
            skills: skills,
            mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
            locations: aggReq?.job_description_keys?.locations || [],
            mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
            mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
            companies: aggReq?.job_description_keys?.companies || [],
            mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
            industries: aggReq?.job_description_keys?.industries || [],
            mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
          }
          payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
          payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
        }
            this.industriesTabPayload =payload

   if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
    this.hasJobDemand = false;
    this.hasMedianSalary = false;
    this.industryJobAggregates = [];
    this.setindustryJobAggregates();
      }else if(!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')){
this.hasJobDemand = false;
    this.hasMedianSalary = false;
    this.industryJobAggregates = [];
    this.setindustryJobAggregates();
      }

      else {
             this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['industry-median_salary'];
      this.hasJobDemand = false;
      this.hasMedianSalary = false;
      this.industryJobAggregates = tempData;
      this.setindustryJobAggregates();

      this.getindustriesdataai(this.industriesSortData);
    })
      }

  } else {
    this.hasJobDemand = false;
    this.hasMedianSalary = false;
    this.industryJobAggregates = [];
    this.setindustryJobAggregates();
  }
  }

formatNumber(value: number): string| number {
  if (value === null || value === undefined || isNaN(value)) return '0';

  const country = this.localstorageservice.getItem('currencyCountry');
  const absNum = Math.abs(value);

  // Optional: you can fetch dynamically if you store currency symbol
  const currencySymbol = country?.toLowerCase() === 'india' ? '₹' : '$';

  const format = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
  };

  if (country?.toLowerCase() === 'india') {

    if (absNum >= 1e7) { // 1,00,00,000
      return format(value / 1e7) + 'Cr';
    }

    if (absNum >= 1e5) { // 1,00,000
      return format(value / 1e5) + 'L';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }

  else {

    if (absNum >= 1e9) {
      return format(value / 1e9) + 'B';
    }

    if (absNum >= 1e6) {
      return format(value / 1e6) + 'M';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }
}


  getCurrency() {
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
             const currency = this.localstorageservice.getItem('jobCurrency');

 if(currency) {
      const selectedCurrency = this.currencyData.find((x:any) => x.target_currency === currency);
      if(selectedCurrency) {
        this.selectedCurrency = selectedCurrency;
        this.target_currency_rate = selectedCurrency.rate;
        this.currency = selectedCurrency.target_currency;
        this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
        this.currency_symbol = selectedCurrency.target_currency_symbol;
      }
    }
    this.getJobsAggregates();
    })
  }

  onTypeAheadSearch(event: any) {
    const input = event.target.value.toLowerCase();
    this.filteredCurrencies = this.currencyData.filter(x => x.target_currency.toLowerCase().includes(input));
    this.filteredCurrencies = this.filteredCurrencies.slice(0, 5);
  }

  selectedItem(currencyItem: any) {
    this.selectedCurrency = currencyItem;
    this.target_currency_rate = currencyItem.rate;
    this.target_fav_icon = currencyItem.target_currency_fav_icon;
    this.currency = currencyItem.target_currency;
    this.currency_symbol = currencyItem.target_currency_symbol;
    this.localstorageservice.setItem('jobCurrency', this.currency);

    this.industriesSortData = this.industriesSortData.map(industry => {
      if (this.target_fav_icon == 'fa-money-bill') {
        industry.median_salary = industry.median_salary_min ? `${this.currency} ${this.formatNumber((industry.median_salary_min) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(industry.median_salary_max * this.target_currency_rate)}` : "N/A";
      } else {
        industry.median_salary = industry.median_salary_min ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((industry.median_salary_min) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(industry.median_salary_max * this.target_currency_rate)}` : "N/A";
      }
      return industry;
    });
    this.getindustriesdataai(this.industriesSortData);
  }

  clearCurrency() {
    this.selectedCurrency = null;
    this.currency = null;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
  }

getCurrencyData(source?: string) {
  const filterData = this.filterDataHandlerService.fetchFilterData;
  const aggReq = this.aggService.getRequestWithFilters();
  if(filterData && filterData.locationSelectedList.length > 0) {
    if(source == 'filterChange') {
      const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext',''));
      const location = locations.join(',');
      const payload = {locations: locations}
      this.talentInsightsService.getLocationCurrency(payload).subscribe((res:any)=>{
        if(res.status === 'success' && res.data){
          this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
          this.localstorageservice.setItem('currencyCountry', res.data.country_name);
          this.setUpdatedData();
        }
      })
    } else {
      this.currency = this.localstorageservice.getItem('jobCurrency');
      this.setUpdatedData();
    }

  } else if(this.jdService.isComingFromJobDescription){
    if(source === 'jdUpdate') {
    if(aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0){
      const locations = aggReq.job_description_keys?.locations;
      const payload = {locations: locations}
      this.talentInsightsService.getLocationCurrency(payload).subscribe((res:any)=>{
        if(res.status === 'success' && res.data){
          this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
          this.localstorageservice.setItem('currencyCountry', res.data.country_name);
          this.setUpdatedData();
        }
      })
    }
   }  else {
          this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
          this.setUpdatedData();


      }
} else {
  this.currency = this.localstorageservice.getItem('jobCurrency');
  this.setUpdatedData();
}

}

  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus(){
    return this.hasMedianSalary || this.hasJobDemand;
  }

  setindustryJobAggregates() {
  const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions')
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
  this.industriesSortData.map(location => {
          location.median_salary = "N/A";
          location.confidence_score = "N/A";
          location.job_doc_count = 0;
        return location;
      });
      } else {
            this.industriesSortData.map(location => {
        const medianSalaryData = this.industryJobAggregates.find(item => item.key.toLowerCase().trim() === location.key.toLowerCase().trim());
        if (medianSalaryData) {
          if (this.target_fav_icon == 'fa-money-bill') {
            location.median_salary = medianSalaryData.median_salary_min.value ? `${this.currency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * (this.target_currency_rate))} - ${this.currency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

          } else {
            location.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * (this.target_currency_rate))} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_max.value) * (this.target_currency_rate))}` : "N/A";

          }
          location.median_salary_min = medianSalaryData.median_salary_min.value;
          location.median_salary_max = medianSalaryData.median_salary_max.value;
          location.confidence_score = medianSalaryData.confidence_score;
          location.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
        } else {
          location.median_salary = "N/A";
          location.confidence_score = "N/A";
          location.job_doc_count = 0;
        }
        return location;
      });
      }
    } else {
        this.industriesSortData.map(location => {
          location.median_salary = "N/A";
          location.confidence_score = "N/A";
          location.job_doc_count = 0;
        return location;
      });
    }

  }

   openJoblistSlider(value:any){
    Object.assign(this.industriesTabPayload, {mandatory_industries:[value]})
      this.sendDataToSliderSubject.next(this.industriesTabPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
  }
}
